export default __webpack_public_path__ + "static/media/mapa.4f00b95a.png";